// extracted by mini-css-extract-plugin
export var bounce = "_oc-1";
export var generatingText = "_oc-6";
export var lightning = "_oc-4";
export var popup = "_oc-5";
export var progressBar = "_oc-7";
export var progressFill = "_oc-8";
export var progressShimmer = "_oc-9";
export var progressText = "_oc-a";
export var shimmer = "_oc-3";
export var uploadIcon = "_oc-0";
export var uploadingText = "_oc-2";